import React, { useRef, useEffect } from "react";
import { Txt } from "../../../components/generalComponets";
import "./stylePlan.css";
import { PLANCARDCOLORS } from "../../../constants/colors";
import { Box, Button } from "../../../components/elements";

export const PlanCard = ({ title, rate, type, count = 0, description = "", index, onEdit, onDelete }) => {
  const titleBackground = PLANCARDCOLORS[index % 4];
  return (
    <div className="plan-card">
      <div className="plan-title-con" style={{ backgroundColor: titleBackground }}>
        <Txt s={20} w="500">
          {title}
        </Txt>
        <Box className="mc-table-action plan-action-btn">
          {onEdit ? (
            <Button title="Edit" className="material-icons edit" onClick={onEdit}>
              edit
            </Button>
          ) : null}
          {onDelete ? (
            <Button title="Delete" className="material-icons delete" onClick={onDelete}>
              delete
            </Button>
          ) : null}
        </Box>
      </div>
      <div className="plan-body">
        <Txt w="500" s={18}>
          Rs: {rate}
        </Txt>
        <div className="fl" style={{ marginTop: 16 }}>
          <Txt c="thrd" fl>
            Type:{" "}
          </Txt>
          <Txt>{type}</Txt>
        </div>
        <div className="fl" style={{ marginTop: 16 }}>
          <Txt c="thrd" fl>
            Customers Count:{" "}
          </Txt>
          <Txt>{count}</Txt>
        </div>

        <Txt mt={16} s={14}>
          {description}
        </Txt>
      </div>
    </div>
  );
};
